import z from 'zod';
import { entitySchema } from '../shared.types';

// ---- Task Schema ----
export const orderTaskSchema = z.object({
    ...entitySchema.shape,
    name: z.string(),
    sameDayOrdinal: z.number().int(),
    baselineId: z.number().int().optional(),
    targetDaysOut: z.number().int().optional(),
    targetStaticDate: z.string().optional().nullable(),
    isActive: z.boolean().optional(),
});

// ---- Request Schemas ----
export const loadOrderTasksFiltersRequestSchema = z.object({
    subscriptionId: z.string(),
    baselineId: z.string(),
    targetDaysOut: z.string(),
    targetStaticDate: z.string(),
    isActive: z.boolean(),
});

export const orderBaselineTasksRequestSchema = z.object({
    subscriptionId: z.string(),
    baselineId: z.string(),
    targetDaysOut: z.string(),
    targetStaticDate: z.string(),
    baselineTasks: z.array(orderTaskSchema),
});

// ---- Response Schemas ----
export const loadOrderTasksFiltersResponseSchema = z.object({
    baselineTasks: z.array(orderTaskSchema),
    isError: z.boolean(),
    errors: z.array(z.object({ message: z.string() })),
});

export const orderBaselineTasksResponseSchema = z.object({
    baselineTasks: z.array(orderTaskSchema),
    locationTasks: z.array(z.any()),
    isError: z.boolean(),
    errors: z.array(z.string()),
});

// ---- Type Exports ----
export type OrderTask = z.infer<typeof orderTaskSchema>;
export type LoadOrderTasksFiltersRequest = z.infer<typeof loadOrderTasksFiltersRequestSchema>;
export type OrderBaselineTasksRequest = z.infer<typeof orderBaselineTasksRequestSchema>;
export type LoadOrderTasksFiltersResponse = z.infer<typeof loadOrderTasksFiltersResponseSchema>;
export type OrderBaselineTasksResponse = z.infer<typeof orderBaselineTasksResponseSchema>;